import React from 'react';
import { Container, Row, Col, Button, Card } from 'react-bootstrap';
import './CommitmentSection.css';
import whoWe from '../assets/about-1.png';
import clientImage from '../assets/client-33.JPG';

const CommitmentSection = () => {
  return (
    <section className="commitment-section py-5">
      <Container>
        <Row className="align-items-center">
          <Col md={6}>
            <div className="left-image h-800 e-flex align-items-center slide-in-left">
              <img src={whoWe} alt="Woman on phone" className="img-fluid rounded w-100 h-200" />
            </div>
          </Col>

          <Col md={6} className="e-flex align-items-center slide-in-right">
            <div className="content-wrapper">
              <p className="text-uppercase text-purple1 fw-semibold mb-2">Who we are</p>
              <h1 className="fw-bold  mb-3">
                Our Commitment To Quality <br />
                And Attention To Detail In <br />
                Event Excellence.
              </h1>
              <p className="text-muted1 mb-4">
                Zarinova Entertainment is driven by the belief that every event should be a story worth telling.
                The company's mission is to deliver world-class event experiences through a blend of creativity,
                professionalism, and meticulous planning
              </p>

              <Row className="mb-4 g-3 text-white">
               <Col xs={12} md={6} className="mb-4 mb-md-0">
  <Card className="shadow-sm border-0 text-white h-100 bg-purple p-3 rounded-4 slide-in-left">
    <Card.Body className="text-center text-md-start">
      <i className="bi bi-bookmark fs-4"></i>
      <Card.Title className="fw-bold mt-2 text-white">
        Your Trusted Partner
      </Card.Title>
      <Card.Text className="fw-bold6 mt-2 text-white">
        We empower your business with innovative solutions.
      </Card.Text>
    </Card.Body>
  </Card>
</Col>

                <Col md={6}>
                  <img
                    src={clientImage}
                    alt="Happy woman"
                    className="img-fluid rounded-4  slide-in-right"
                  />
                </Col>
              </Row>

              <ul className="list-unstyled  text-muted1 fs-5 mb-4">
                <li className="mb-2">
                  <i className="bi bi-check-circle-fill text-white me-2"></i>
                  Tailored strategies to meet your business goals
                </li>
                <li>
                  <i className="bi bi-check-circle-fill text-white me-2"></i>
                  Reliable support with a focus on long-term success
                </li>
              </ul>

           
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default CommitmentSection;
